/**
 * Pokemon TCG configuration
 * This file contains constants and configuration for Pokemon TCG cards
 */

export const POKEMON_TYPES = [
  { id: 'colorless', name: 'Colorless' },
  { id: 'darkness', name: 'Darkness' },
  { id: 'dragon', name: 'Dragon' },
  { id: 'fairy', name: 'Fairy' },
  { id: 'fighting', name: 'Fighting' },
  { id: 'fire', name: 'Fire' },
  { id: 'grass', name: 'Grass' },
  { id: 'lightning', name: 'Lightning' },
  { id: 'metal', name: 'Metal' },
  { id: 'psychic', name: 'Psychic' },
  { id: 'water', name: 'Water' },
];

export const POKEMON_RARITIES = [
  { id: 'common', name: 'Common' },
  { id: 'uncommon', name: 'Uncommon' },
  { id: 'rare', name: 'Rare' },
  { id: 'rareHolo', name: 'Rare Holo' },
  { id: 'rareUltra', name: 'Rare Ultra' },
  { id: 'rareSecret', name: 'Rare Secret' },
  { id: 'rareHoloEX', name: 'Rare Holo EX' },
  { id: 'rareHoloGX', name: 'Rare Holo GX' },
  { id: 'rarePrism', name: 'Rare Prism Star' },
  { id: 'amazingRare', name: 'Amazing Rare' },
  { id: 'rareHoloLvX', name: 'Rare Holo Lv.X' },
  { id: 'rareACE', name: 'Rare ACE' },
  { id: 'rareBreak', name: 'Rare BREAK' },
  { id: 'rarePrime', name: 'Rare Prime' },
  { id: 'rareShiny', name: 'Rare Shiny' },
  { id: 'rareShiningHolofoil', name: 'Rare Shining Holofoil' },
  { id: 'rareHoloStar', name: 'Rare Holo Star' },
  { id: 'promo', name: 'Promo' },
];

export const POKEMON_SUPERTYPES = [
  { id: 'pokemon', name: 'Pokémon' },
  { id: 'trainer', name: 'Trainer' },
  { id: 'energy', name: 'Energy' },
];

export const POKEMON_SUBTYPES = [
  { id: 'basic', name: 'Basic' },
  { id: 'stage1', name: 'Stage 1' },
  { id: 'stage2', name: 'Stage 2' },
  { id: 'ex', name: 'EX' },
  { id: 'gx', name: 'GX' },
  { id: 'mega', name: 'MEGA' },
  { id: 'vmax', name: 'VMAX' },
  { id: 'vstar', name: 'VSTAR' },
  { id: 'v', name: 'V' },
  { id: 'tagteam', name: 'Tag Team' },
  { id: 'item', name: 'Item' },
  { id: 'supporter', name: 'Supporter' },
  { id: 'stadium', name: 'Stadium' },
  { id: 'tool', name: 'Tool' },
  { id: 'special', name: 'Special' },
  { id: 'rapidstrike', name: 'Rapid Strike' },
  { id: 'singlestrike', name: 'Single Strike' },
  { id: 'fusionStrike', name: 'Fusion Strike' },
  { id: 'radiant', name: 'Radiant' },
  { id: 'legend', name: 'LEGEND' },
  { id: 'restored', name: 'Restored' },
  { id: 'levelup', name: 'Level-Up' },
  { id: 'break', name: 'BREAK' },
  { id: 'prismstar', name: 'Prism Star' },
  { id: 'ace', name: 'ACE SPEC' },
];

export const POKEMON_CONDITIONS = [
  { id: 'mint', name: 'Mint (MT)' },
  { id: 'nearMint', name: 'Near Mint (NM)' },
  { id: 'excellent', name: 'Excellent (EX)' },
  { id: 'good', name: 'Good (GD)' },
  { id: 'played', name: 'Played (PL)' },
  { id: 'poor', name: 'Poor (PR)' },
];

export const POKEMON_LANGUAGES = [
  { id: 'english', name: 'English' },
  { id: 'japanese', name: 'Japanese' },
  { id: 'french', name: 'French' },
  { id: 'german', name: 'German' },
  { id: 'italian', name: 'Italian' },
  { id: 'spanish', name: 'Spanish' },
  { id: 'portuguese', name: 'Portuguese' },
  { id: 'korean', name: 'Korean' },
  { id: 'chinese', name: 'Chinese' },
];

export const POKEMON_FINISHES = [
  { id: 'regular', name: 'Regular' },
  { id: 'holofoil', name: 'Holofoil' },
  { id: 'reverseHolofoil', name: 'Reverse Holofoil' },
  { id: 'fullArt', name: 'Full Art' },
  { id: 'textured', name: 'Textured' },
  { id: 'etched', name: 'Etched Holofoil' },
  { id: 'gold', name: 'Gold Star' },
  { id: 'rainbow', name: 'Rainbow Rare' },
  { id: 'alternateArt', name: 'Alternate Art' },
];

export const POKEMON_EDITIONS = [
  { id: 'first', name: '1st Edition' },
  { id: 'unlimited', name: 'Unlimited' },
  { id: 'shadowless', name: 'Shadowless' },
];
